// ##### Komarov 2025-07-18
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// ##### 25-01-22 Komarov
import { DownOutlined } from '@ant-design/icons';
import { Media } from '../../../../helpers/MediaConfig.js';
// ##### Komarov 2025-07-18
import { getPax, setPaxListOpen } from '../../../../Redux/actions';
// ##### 25-05-21 Komarov
import Pax from '../../Icons/pax.jsx';

// ##### Komarov 2025-07-14
const HotelsPaxResultPageDevices = ({
  className,
  width = null,
  // screenWidthClassName = ''
}) => {
  // ##### Komarov 2025-07-19
  const { adults: counterAdults, children: counterChild, rooms: counterRooms } = useSelector(state => state.paxchoice.pax);

  // ##### Komarov 2025-08-05
  const Adults = useSelector(state => state.pagesRedux[state.language]?.Adults || '');
  const Children = useSelector(state => state.pagesRedux[state.language]?.Children || '');
  const Rooms = useSelector(state => state.pagesRedux[state.language]?.Rooms || '');

  const dispatch = useDispatch();

  // ##### Komarov 2025-07-18
  const TotalPax = () => {
    dispatch(getPax(counterAdults, counterChild, counterRooms));
  };

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(getPax(counterAdults, counterChild, counterRooms));
    // ##### 23-04-12 Komarov
  }, [counterAdults, counterChild, counterRooms, dispatch]);

  // console.log('CHECKING' , pax)
  // ##### 23-11-08 Komarov
  return (
    <div
      data-component="HotelPaxResult"
      className={className}
      style={{ width }}
      // ##### 23-12-27 Komarov
      onClick={e => {
        dispatch(setPaxListOpen(true));
        e.stopPropagation();
      }}
      // ##### 24-03-21 Komarov
      onKeyDown={e => {
        if (e.key === 'Enter') {
          dispatch(setPaxListOpen(true));
          e.stopPropagation();
        }
      }}
    >
      <h4
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
        }}
        onClick={TotalPax}
        // ##### 24-03-21 Komarov
        onKeyDown={e => {
          if (e.key === 'Enter') {
            TotalPax();
          }
        }}
      >
        <Pax />
        {/* ##### 24-03-21 Komarov */}
        <div style={{ paddingLeft: '1vw', fontSize: '14px' }}>
          {' '}
          {counterAdults} <span style={{ marginLeft: '3px' }} />
          {
            // ##### 23-10-04 Komarov
            Adults
          }
        </div>
        ,{/* ##### 24-03-21 Komarov */}
        <div style={{ paddingLeft: '1vw', fontSize: '14px' }}>
          {' '}
          {counterChild}
          <span style={{ marginLeft: '3px' }} />
          {
            // ##### 23-10-04 Komarov
            Children
          }
        </div>
        ,{/* ##### 24-03-21 Komarov */}
        <div style={{ paddingLeft: '1vw', fontSize: '14px' }}>
          {' '}
          {counterRooms} <span style={{ marginLeft: '3px' }} />
          {
            // ##### 23-10-04 Komarov
            Rooms
          }
        </div>
        {/* ##### 23-11-08 Komarov */}
        <Media greaterThanOrEqual="Laptop-1024-1440">
          <DownOutlined className="DownOutlined" />
        </Media>
        <Media lessThan="Laptop-1024-1440">
          <DownOutlined className="DownOutlined_SmallPortrait" />
        </Media>
      </h4>
    </div>
  );
};

// ##### 25-05-21 Komarov
export default HotelsPaxResultPageDevices;
